/**
 * Storage Keys Registry
 * Single source of truth for all localStorage keys used in the application.
 * Centralizing keys prevents typos and makes key audits trivial.
 */
export const STORAGE_KEYS = {
  THEME: 'theme',
  FAVORITES: 'umituz_blog_favorites',
  ANALYTICS: 'umituz_analytics',
} as const

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS]
